module.exports = __webpack_public_path__ + "img/319.25ec3fc7.jpg";